
<div [formGroup]="contactform" id="contactform" class="flex justify-center">
  <div class="flex flex-col px-2 rounded-lg max-w-[500px]">
    <h2>{{'contactform.contactform'| translate}}</h2>
    <div class="form-field ">
      <label>{{'contactform.category.title' | translate}}</label>
      <select formControlName="subject" id="subject" type="text">
        @for (category of categories; track category) {
          <option value="{{'contactform.category.' + category |translate}}">
            {{'contactform.category.' + category |translate}}
          </option>
        }
      </select>
      @if (hasError('subject', 'required')) {
        <small class="error" [@collapse]>{{'validation.required' | translate}}</small>
      }
    </div>

    <div class="form-field">
      <label>{{'contactform.email' | translate}}*</label>
      <input formControlName="email" id="email" name="email" required type="email">
      @if (hasError('email', 'required')) {
        <small class="error" [@collapse]>{{'validation.email_required' | translate}}</small>
      }
      @if (hasError('email', 'email_invalid')) {
        <small class="error" [@collapse]>{{'validation.email_invalid' | translate}}</small>
      }
    </div>
    <div class="form-field">
      <label>{{'contactform.name' | translate}}*</label>
      <input formControlName="name" id="name" name="name" required type="text">
      @if (hasError('name', 'required')) {
        <small class="error whitespace-nowrap" [@collapse]>{{'validation.required' | translate}}</small>
      }
    </div>
    <div class="form-field">
      <label>{{'contactform.description' | translate}}*</label>
      <textarea formControlName="description" id="description" name="description" class="h-[175px]"></textarea>
      @if (hasError('description', 'required')) {
        <small class="error" [@collapse]>{{'validation.maxlength_value' | translate }}</small>
      }
      @if (hasError('description', 'maxlength')) {
        <small class="error" [@collapse]>{{'validation.maxlength_value' | translate: {value:500} }}</small>
      }
    </div>

    <button class="button-cta rounded-lg mt-3" [disabled]="!contactform.valid" (click)="sendContactform()">{{'contactform.send' | translate}}</button>
  </div>

</div>
